import { useServices } from 'core/services';
import { BaseHttpError } from 'core/services/api/errors';
import { CommentsResponse } from 'core/services/api/response-types';
import { Comment } from 'core/types';
import { getPageParams } from 'core/utils/pagination';
import { discussionKeys } from 'core/utils/query-key-factory';
import { useInfiniteQuery, InfiniteData } from '@tanstack/react-query';

export const useGetComments = (
	discussionId: string,
	options: {
		enabled?: boolean;
		refreshInterval?: number | false;
	} = {
		enabled: true,
		refreshInterval: false,
	}
) => {
	const { api, authentication } = useServices();

	const isLoggedIn = authentication.isAuthenticated();

	const commentsQuery = useInfiniteQuery<
		CommentsResponse,
		BaseHttpError,
		InfiniteData<Comment[]>
	>({
		queryKey: discussionKeys.comments(discussionId),
		queryFn: ({ pageParam = undefined, signal }) =>
			api.getComments(discussionId, {
				pagination: pageParam as any,
				signal,
			}),
		initialPageParam: undefined,
		enabled: !!discussionId && isLoggedIn && options.enabled,
		select: data => {
			return {
				pages: data.pages.map(page => page.data),
				pageParams: data.pageParams,
			};
		},
		refetchInterval: options.refreshInterval,
		getPreviousPageParam: firstPage =>
			getPageParams(firstPage.pagination).previousParam,
		getNextPageParam: lastPage =>
			getPageParams(lastPage.pagination).nextParam,
		refetchOnMount: true,
	});

	return commentsQuery;
};
